import React, { FunctionComponent } from 'react'

import { getFormatter } from './maps'
import { Formatter } from './types'

export const FormFormatter: FunctionComponent<Formatter> = ({ input, ...props }) => {
  const Formatter = getFormatter(input.type)
  return <Formatter {...props} input={input} />
}
